import { IEnum, IEnumValue } from '@/pages/MDM/mdm.types.ts'
import usePrimitive from '@/pages/MDM/hooks/usePrimitive.ts'
import { useMemo } from 'react'
import DropdownInput from 'src/shared/Inputs/DropdownInput'

interface IProps {
  primitiveId: IEnum['id']
  value: IEnumValue['id']
  name: string
  onChange: (val: IEnumValue['id'], name: string) => void
  placeHolder?: string
}

const PrimitiveValueDropdown = (props: IProps) => {
  const primitive = usePrimitive(props.primitiveId)

  const options = useMemo(() => {
    return primitive.values.map((v) => ({ title: v.name, value: v.id }))
  }, [primitive])

  return (
    <DropdownInput
      options={options}
      name={props.name}
      selectedOption={props.value as any}
      title={props.placeHolder || 'Выберите значения'}
      onSelect={props.onChange}
    />
  )
}

export default PrimitiveValueDropdown
